var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "formula-editor" },
    [
      _c("codemirror", {
        ref: "codeEditor",
        attrs: { options: _vm.codeMirrorOptions },
        on: { input: _vm.handleCodeMirrorChange },
        model: {
          value: _vm.formulaStr,
          callback: function ($$v) {
            _vm.formulaStr = $$v
          },
          expression: "formulaStr",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }